import { Box, ButtonLayout, Grid, GridItem, Stack, useScreenSize } from "@telefonica/mistica";
import { observer } from "mobx-react-lite";
import React from "react";
import type { HeroDataInfoProps, ScreenResponsiveProps } from "../../organisms";
import { HeroDataInfo, ScreenResponsive } from "../../organisms";
import type { ButtonProps } from "../../atoms";
import { Button } from "../../atoms";
import { useScreenViewHeight } from "../../../hooks";
import { LoadingContainer } from "../../LoadingContainer";

interface IProps {
	buttonProps?: ButtonProps;
	screenResponsiveProps?: ScreenResponsiveProps;
	heroDataInfoProps: HeroDataInfoProps;
	loading?: boolean;
}

const Feedback: React.FC<IProps> = observer((props) => {
	const { buttonProps, heroDataInfoProps, screenResponsiveProps, loading } = props;
	const { isDesktopOrBigger } = useScreenSize();
	const { height } = useScreenViewHeight(!!screenResponsiveProps?.navigationTitle);

	return (
		<ScreenResponsive {...screenResponsiveProps}>
			<Grid height={height} justifyContent="center">
				<Box paddingX={8} paddingY={isDesktopOrBigger ? 40 : 32}>
					<Box width={!isDesktopOrBigger ? "100%" : 600} className="space-between-vertical">
						<Stack space={40}>
							<HeroDataInfo {...heroDataInfoProps} />
						</Stack>
						{buttonProps && (
							<Box paddingTop={isDesktopOrBigger ? 40 : 0}>
								<ButtonLayout>
									<Button {...buttonProps} />
								</ButtonLayout>
							</Box>
						)}
					</Box>
				</Box>

				{loading && (
					<Grid justifyContent="center">
						<Grid alignItems="center">
							<GridItem>
								<Box paddingTop={64}>
									<LoadingContainer title="" />
								</Box>
							</GridItem>
						</Grid>
					</Grid>
				)}
			</Grid>
		</ScreenResponsive>
	);
});

export default Feedback;
